import {
  type BadgeVariant,
  getStatusConfig,
  getVariantClasses,
  type StatusType,
} from '../../constants/statusConfig';
import { cn } from '../../lib/utils';

export type { BadgeVariant };

interface StatusBadgeProps {
  status: string;
  variant?: BadgeVariant;
  className?: string;
}

interface TypedStatusBadgeProps {
  type: StatusType;
  status: string;
  className?: string;
}

export function StatusBadge({
  status,
  variant = 'default',
  className,
}: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        getVariantClasses(variant),
        className,
      )}
    >
      {status}
    </span>
  );
}

export function TypedStatusBadge({
  type,
  status,
  className,
}: TypedStatusBadgeProps) {
  const config = getStatusConfig(type, status);
  return (
    <StatusBadge
      status={config.label}
      variant={config.variant}
      className={className}
    />
  );
}
